import { getToken } from '@optimus-web/common';
import { AlertVariant } from './types';

export const getAlertItemIconBackgroundColor = (variant: AlertVariant) => {
    switch (variant) {
        case AlertVariant.Error:
            return getToken('backgroundAlertDangerSecondary');
        case AlertVariant.Info:
            return getToken('backgroundAlertInfoSecondary');
        case AlertVariant.Success:
            return getToken('backgroundAlertSuccessSecondary');
        case AlertVariant.Warning:
            return getToken('backgroundAlertWarningSecondary');
    }
};

export const getAlertItemIconColor = (variant: AlertVariant) => {
    switch (variant) {
        case AlertVariant.Error:
            return getToken('textAlertDanger');
        case AlertVariant.Info:
            return getToken('textAlertInfo');
        case AlertVariant.Success:
            return getToken('textAlertSuccess');
        case AlertVariant.Warning:
            return getToken('textAlertWarning');
    }
};
